import React, { useCallback } from 'react';
import { useObservable } from 'react-use-observable';

import { DoubleRightOutlined } from '@ant-design/icons';
import { Button, Col, Row } from 'antd';

import PermissionHide from 'v2/components/Shared/PermissionHide';
import ordersService from 'v2/services/orders';

import { Export } from './Export';

export const Details = () => {
  const openModalTrackingCodes = useCallback(() => ordersService.openModalTrackingCodes(), []);
  const [totalItems] = useObservable(() => ordersService.getTotalItems(), []);
  const [loading] = useObservable(() => ordersService.isLoading(), []);

  if (loading) return null;

  return (
    <>
      <div
        className='relative top-0 z-[15] w-full rounded-sm bg-white p-4 text-center shadow-[0_1px_0_0_rgba(0,0,0,0.07)] min-[600px]:sticky min-[600px]:bottom-0 min-[600px]:z-[15] min-[600px]:mb-4 min-[600px]:rounded-sm min-[600px]:bg-white min-[600px]:py-0 min-[600px]:pr-0 min-[600px]:pl-4 min-[600px]:shadow-[0_1px_0_0_rgba(0,0,0,0.07)]'
        id='orders-details'
      >
        <Row justify='space-between' align='middle' gutter={16}>
          <Col>
            <span id='orders-result-button-label' className='font-semibold'>
              {totalItems || 0} entregas
            </span>
          </Col>

          <Col className='flex'>
            <PermissionHide action='myeduzz:minhas-entregas:editar'>
              <Button
                id='batch-screening'
                type='text'
                disabled={!totalItems}
                onClick={openModalTrackingCodes}
                icon={<DoubleRightOutlined />}
              >
                Rastreio em Lote
              </Button>
            </PermissionHide>
            <PermissionHide action='myeduzz:minhas-entregas:exportar'>
              <Export />
            </PermissionHide>
          </Col>
        </Row>
      </div>
    </>
  );
};
